export const TERMINAL = new Set(["completed", "failed", "killed", "abstained"]);
